<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template v-slot:header>
              <h4 class="card-title">{{ title }}</h4>
              <p class="card-category">{{ description }}</p>
            </template>

            <div class="row mt-3">
              <div class="col-md-12 p-0">
                <div class="table-responsive">
                  <l-table
                    class="table table-hover address text-xs"
                    style="width: 100%"
                    :columns="tableData.columns"
                    :data="Payments"
                    :rejectedStatus="rejectedStatus"
                    :openUploadElement="openUploadElement"
                    :buttons="buttons"
                    :metaInfo="metaInfo"
                    :loadData="loadElements"
                  >
                  </l-table>
                </div>

                <!-- MODAL UPLOAD IMAGE -->
                <div
                  :class="[
                    'custom-modal-payment',
                    modalActiveUpdate
                      ? 'modal fade show disable-scroll'
                      : 'modal fade',
                  ]"
                  :style="{ display: modalActiveUpdate ? 'block' : 'none' }"
                  :id="'modalPostulation'"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    class="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div class="modal-content p-0">
                      <div class="modal-header custom-header">
                        <h2
                          class="modal-title w-100 text-center m-0 text-white"
                        >
                          Detalles del pago
                        </h2>
                        <button
                          type="button"
                          class="close custom-close"
                          data-dismiss="modal"
                          aria-label="Close"
                          @click.prevent="closeUploadElement"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body p-4">
                        <form>
                          <div class="row">
                            <div
                              class="col-md-12"
                              v-if="
                                form_update.user_platform &&
                                form_update.user_platform.platform &&
                                form_update.user_platform.platform.name
                              "
                            >
                              <base-input
                                label="Curso"
                                class="custom-input mb-md-0"
                                :value="form_update.user_platform.platform.name"
                                readonly
                              />
                            </div>
                            <div class="col-12 col-md-6">
                              <base-input
                                label="Banco emisor"
                                class="custom-input mb-md-0"
                                :value="form_update.origin_bank"
                                readonly
                              />
                            </div>
                            <div class="col-12 col-md-6">
                              <base-input
                                label="Banco receptor"
                                class="custom-input mb-md-0"
                                :value="form_update.company_bank.name_bank"
                                readonly
                              />
                            </div>
                            <div class="col-12 col-md-6" v-if="form_update.currency === 'USD'">
                              <base-input
                                label="Monto pagado (USD)"
                                class="custom-input mb-md-0"
                                :value="'$' + amountUsdFormatted"
                                readonly
                              />
                            </div>
                            <div class="col-12 col-md-6" v-if="form_update.currency === 'USD'">
                              <base-input
                                label="Monto en bolívares"
                                class="custom-input mb-md-0"
                                :value="'Bs.' + amountFormatted"
                                readonly
                              />
                            </div>
                            <div class="col-12 col-md-6" v-if="form_update.currency !== 'USD'">
                              <base-input
                                label="Monto pagado"
                                class="custom-input mb-md-0"
                                :value="'Bs.' + amountFormatted"
                                readonly
                              />
                            </div>
                            <div class="col-12 col-md-6">
                              <base-input
                                label="Tasa BCV"
                                class="custom-input mb-md-0"
                                :value="'Bs.' + bcvRateFormatted"
                                readonly
                              />
                            </div>
                            <div class="col-12 col-md-6">
                              <base-input
                                label="Fecha de pago"
                                class="custom-input mb-md-0"
                                :value="form_update.date"
                                readonly
                              />
                            </div>
                            <div class="col-12 col-md-6">
                              <base-input
                                label="Referencia"
                                class="custom-input mb-md-0"
                                :value="form_update.reference"
                                readonly
                              />
                            </div>
                          </div>
                          <div class="row" v-if="form_update.url_image">
                            <div
                              class="col-md-12 d-flex flex-column align-items-center"
                            >
                              <label for="payment-capture"
                                >Captura del pago</label
                              >
                              <img
                                :src="form_update.url_image"
                                alt="Captura del pago"
                                class="img-fluid"
                                style="max-width: 300px; max-height: 200px"
                              />
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function clearAccents(cadena) {
  let chars = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
    à: "a",
    è: "e",
    ì: "i",
    ò: "o",
    ù: "u",
    ñ: "n",
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ú: "U",
    À: "A",
    È: "E",
    Ì: "I",
    Ò: "O",
    Ù: "U",
    Ñ: "N",
  };
  let expr = /[áàéèíìóòúùñ]/gi;
  let res = cadena.replace(expr, function (e) {
    return chars[e];
  });
  return res;
}

import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import LTable from "src/components/Table.vue";
import Card from "src/components/Cards/Card.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Cookies from "js-cookie";
import moment from "moment";
import BaseInput from "src/components/Inputs/BaseInput.vue";

export default {
  components: {
    LTable,
    Card,
    Multiselect,
    BaseInput,
  },
  data() {
    return {
      //LABELS
      title: "Mis pagos",
      description: "Acá podras ver los pagos que haz realizado y el estatus de los mismos, recuerda que solo podrás reportar pagos a postulaciones aprobadas",
      buttonNewLabel: "Agregar nuevo usuario",
      buttonNewUrl: "UserIDNew",
      buttonEditUrl: "UserIDEdit",
      finderLabel: "Buscar",
      filterLabel: "Seleccione",
      listVisible: false,
      //FILTERS
      filter_stocks: "",
      //VARIABLE
      finder: "",
      metaInfo: {},
      isBusy: false,
      //MODAL
      modalActiveUpdate: false,
      idTmp: 0,
      filesUser: [],

      form_save: {
        id_user_platform: "",
        name: "",
        url_file: "",
      },

      form_update: {
        id: 0,
        phone: "",
        company_bank: {
          id: 0,
          name_bank: "",
          currency: "",
        },
        bcv_rate: {
          id: 0,
          value: "",
        },
        reference: "",
        origin_bank: "",
        amount: "",
        amount_usd: "",
        currency: "",
        user_platform: {
          id: 0,
          platform: {
            id: 0,
            name: "",
            amount: 0,
          },
        },
        date: "",
        url_image: "",
      },

      data: [
        {
          profile_image: "../img/faces/face-0.jpg",
        },
      ],
      //TABLE DATA
      tableData: {
        columns: [
          {
            name: "Banco receptor",
            key: "company_bank.name_bank",
          },
          // {
          //   name: "Curso",
          //   key: "user_platform.platform.name",
          // },
          {
            name: "Monto",
            key: "amountFormatted",
          },
          {
            name: "Curso",
            key: "user_platform.platform.name",
          },
          {
            name: "Estado",
            key: "type_status_payment.name",
          },
          {
            name: "Fecha de pago",
            key: "date",
          },
          {
            name: "Acciones",
            key: "actions",
          },
        ],
        data: [],
      },
      //DATA Variables
      Payments: [],
      stockTmp: [],
      //TABLE Buttons
      buttons: [
        {
          icon: "eye",
          icon_negative: "eye",
          type_button: "btn-info",
          tooltip: "Ver pago",
          url: "",
          type_action: "go_method",
          action: "openUploadElement",
          fill_icon: "#FFC700",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    rows() {
      return this.PaymentsTmp.length;
    },
    amountFormatted() {
      if (!this.form_update.amount) return "";
      const value = Number(this.form_update.amount);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    bcvRateFormatted() {
      if (!this.form_update.bcv_rate.value) return "";
      const value = Number(this.form_update.bcv_rate.value);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    amountToPayFormatted() {
      if (!this.form_update || !this.form_update.amount) return "";
      const value = Number(this.form_update.amount);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    amountUsdFormatted() {
      if (!this.form_update.amount_usd) return "";
      const value = Number(this.form_update.amount_usd);
      if (isNaN(value)) return "";
      return value.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  mounted() {
    this.loadElements();
  },
  updated() {
    // console.log(this.user);
  },
  methods: {
    ...mapActions([
      "getData",
      "getDataLite",
      "changeStatusData",
      "updateData",
      "createData",
    ]),

    showList() {
      this.listVisible = true;
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    goNew() {
      this.$router.push({ name: this.buttonNewUrl });
    },

    openUploadElement(data) {
      // Copiar datos base del pago
      this.form_update = {
        ...this.form_update,
        ...data,
      };

      // Asegurar estructura user_platform y platform para el modal
      if (!this.form_update.user_platform) {
        this.form_update.user_platform = {
          id: data.user_platform ? data.user_platform.id : 0,
          platform: {
            id: 0,
            name: "",
            amount: 0,
          },
        };
      }

      if (!this.form_update.user_platform.platform) {
        this.form_update.user_platform.platform = {
          id: 0,
          name: "",
          amount: 0,
        };
      }

      // Nombre del curso (si existe en la respuesta)
      const platformName =
        (data.user_platform &&
          data.user_platform.platform &&
          data.user_platform.platform.name) ||
        (data.platform && data.platform.name) ||
        this.form_update.user_platform.platform.name ||
        "";

      this.form_update.user_platform.platform.name = platformName;

      this.idTmp = data.id;
      console.log("OPEN UPLOAD MODAL");
      this.modalActiveUpdate = true;
    },

    closeUploadElement() {
      console.log("CLOSING UPLOAD MODAL");
      this.modalActiveUpdate = false;
    },

    loadUserFiles(data) {
      if (data.id_type_status != 3) {
        let data_params = {
          url: "user_file_platform/all",
          params: {
            active: 1,
            id_user_platform: data.id,
            order_by: "id",
            order_value: "asc",
          },
        };

        this.getData(data_params)

          .then((response) => {
            if (response.code == 200) {
              this.filesUser = response.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    deleteFile(id) {
      Swal.fire({
        title: "¿Estás seguro de eliminar este archivo?",
        text: "No podrás revertir esta acción",
        icon: "warning",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#048224ff",
        cancelButtonColor: "#abb2ba",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí, eliminar",
      }).then((result) => {
        if (result.value) {
          let data_form;
          data_form = {
            active: 2,
          };
          let form = {
            url: "user_file_platform/update",
            id: id,
            data: data_form,
          };
          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadUserFiles(this.form_update);
              }
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un error, intente más tarde");
            });
        }
      });
    },

    loadElements() {
      let form = {
        url: "user/payment_report/all",
        params: {
          active: 1,
          page: 1,
          limit: 10,
          order_value: "id",
          order_value: "desc",
          id_user: Cookies.get("id"),
        },
      };

      if (this.metaInfo.current_page > 1) {
        form.params.page = this.metaInfo.current_page;
      }

      if (this.finder != "") {
        console.log("Searching:" + this.finder);
        form.params.query = this.finder;
        form.params.page = 1;
      }
      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          response.data.data.forEach((element) => {
            element.date = moment(element.date).format("DD/MM/YYYY");
            element.amountFormatted =
              "Bs. " +
              Number(element.amount).toLocaleString("es-VE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
            // element.amount =
            //   element.company_bank.currency == "USD"
            //     ? "$" + element.amount
            //     : "Bs. " + element.amount;
            // element.bcv_rate.value = " Bs." + element.bcv_rate.value ;
          });
          if (response.code === 200) {
            this.Payments = response.data.data;
            this.metaInfo = response.data.meta;
            this.PaymentsTmp = this.Payments;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    uploadFiles() {
      const filePondInstance = this.$refs.filePond.getFiles();
      if (filePondInstance && filePondInstance.length > 0) {
        Swal.fire({
          title: "Subiendo archivos...",
          icon: "info",
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        const promises = [];
        for (let i = 0; i < filePondInstance.length; i++) {
          let data_form;
          data_form = new FormData();
          const file = filePondInstance[i].file;
          const fileName = file.name;
          data_form.append("url_file", file);
          data_form.append("name", fileName);
          data_form.append("id_user_platform", this.form_update.id);
          let form = {
            url: "user_file_platform/save",
            data: data_form,
          };
          promises.push(this.createData(form));
        }

        Promise.all(promises)
          .then((responses) => {
            // Handle success
            this.deleting = false;
            this.closeUploadElement();
            this.loadUserFiles(this.form_update);
          })
          .catch((error) => {
            console.log(error);
            alert("Ocurrió un error, intente más tarde");
          })
          .finally(() => {
            Swal.close();
            Swal.fire({
              title: "Postulación actualizada correctamente",
              text: "Ahora debes esperar a que respondan tu solicitud",
              icon: "success",
              showConfirmButton: true,
              showLoaderOnConfirm: true,
            });
          });
      }
      this.$refs.filePond.removeFiles();
    },
    rejectedStatus(data) {
      let title = "Eiminar postulación";

      let text = "¿Estás seguro de eliminar su postulación?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#B49B57",
        cancelButtonColor: "#9F9F9F",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let data_form = new FormData();
          data_form.append("active", 2);
          let form = {
            id: data.id,
            url: "user/user_platform/update",
            data: data_form,
          };
          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadElements();
                // data.active = active;
                Swal.fire({
                  title: "La postulación fue eliminada",
                  icon: "success",
                });
                this.loadElements();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style>
.address {
  min-width: 800px;
}

.address td:nth-child(4) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 120px;
  width: 120px;
}

.address td:last-child {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  justify-content: center;
  max-width: 200px;
}

.address td:last-child .btn {
  flex: 1 0 auto;
  margin: 1px;
  /* Reducir la distancia entre botones */
}

.button-search {
  height: 100%;
  margin-left: 5px;
}

.my-table th:last-child {
  width: 35%;
}

.table-container {
  width: auto;
  max-width: 3000px;
  /* ajusta el valor al ancho máximo que desees */
  overflow-x: auto;
  align-items: center;
  text-align: center;
}

.l-table {
  width: 100%;
  table-layout: fixed;
}

.l-table td,
.l-table th {
  white-space: nowrap;
}

.my-button {
  margin-left: 10px;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 1px solid black;
  padding: 10px;
}

.custom-rounded-multiselect .multiselect__tags {
  border-radius: 2rem;
}

.custom-rounded-multiselect .multiselect__tags .multiselect__tag {
  border-radius: 2rem;
}

.custom-placeholder::placeholder {
  font-size: 14px;
  color: #cfcfca;
  display: inline-block;
  font-weight: 600;
}

/* MODAL PAYMENT REPORT custom styles */
.custom-modal-payment .modal-content {
  border-radius: 22px;
  box-shadow: 0 8px 32px rgba(53, 16, 32, 0.18);
  background: #6d263a;
  padding: 0;
  overflow: hidden;
  border: none;
}
.custom-modal-payment .custom-header {
  background: #6d263a;
  color: #fff;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
  padding: 1.5rem 1rem 1rem 1rem;
  position: relative;
  border: none;
}

.modal-body {
  background: #fff;
  border-radius: 22px;
}

.custom-modal-payment .modal-title {
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 1px;
}
.custom-modal-payment .custom-close {
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  color: #fff;
  font-size: 2rem;
  background: none;
  border: none;
  opacity: 1;
}

.custom-modal-payment .btn.custom-btn-main {
  background: #6d263a;
  color: #fff;
  border-radius: 12px;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 0.8rem 0;
  width: 100%;
  box-shadow: 0 2px 8px rgba(109, 38, 58, 0.08);
  transition: background 0.2s;
}
.custom-modal-payment .btn.custom-btn-main:hover {
  background: #a14e5a;
}
</style>
